import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-content-block',
  imports: [],
  templateUrl: './content-block.html',
  styleUrl: './content-block.scss',
})
export class ContentBlock {
  h100 = input<boolean | undefined>();
}
